export default __webpack_public_path__ + "static/media/discussion.0318c70f.png";